import React, { useCallback } from 'react';
import { StyleSheet } from 'react-native';
import Modal from 'utils/packages/Modal';
import { SettingsItem } from 'design-system/SettingsItem';
import { IconBell, IconBoldArrow, IconRectangleListSolid, } from 'design-system/icons';
import { IconWifi } from 'design-system/icons/IconWifi';
import useColors from 'hooks/useColors';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { getGroupById, saveGroupTransaction } from 'actions';
import { selectIsGBUser, selectUser } from 'reducers/selectors';
import { SAVE_GROUP_TRANSACTION_SUCCESS } from 'actions/types';
import { getCreditAndDebt } from 'features/pay/actions/payments';
import { showUnavailableOnWeb } from 'utils/webGate';
const SettleUpModalContent = ({ group, payer, payee, navigation, onRemind, fullAmount, }) => {
    const colors = useColors();
    const dispatch = useAppDispatch();
    const user = useAppSelector(selectUser);
    // UK users can pay through Emma in the app, from the Pay tab or the feed
    const isGBUser = useAppSelector(selectIsGBUser);
    const isPaying = payer.id === user.id;
    const onFromTransactionScreen = useCallback(() => {
        Modal.hide(() => navigation.navigateDeprecated('GroupSelectTransactions', {
            groupId: group.id,
            isMultipleSelect: false,
            type: isPaying ? 'EXPENSE' : 'INCOME',
            onContinue: async (selectedTxn, setIsFetching) => {
                setIsFetching(true);
                const { amount, counterpartName, currency, bookingDate, customDate, id, } = selectedTxn[0];
                const res = await dispatch(saveGroupTransaction(group.id, {
                    amount: -Math.abs(amount),
                    counterpartName,
                    currency,
                    originalTransactionId: id,
                    date: customDate || bookingDate,
                    paidBy: payer.id,
                    split: { [payee.id]: 1 },
                    isSettlement: true,
                }));
                if (res?.type !== SAVE_GROUP_TRANSACTION_SUCCESS) {
                    setIsFetching(false);
                    return;
                }
                await dispatch(getGroupById(group.id));
                dispatch(getCreditAndDebt());
                navigation.pop(2);
                setIsFetching(false);
            },
        }));
    }, [group.id, isPaying, payee.id, payer.id]);
    const onCustomTransaction = useCallback(() => {
        Modal.hide(() => navigation.navigateDeprecated('GroupSettleOffline', {
            group,
            payee,
            payer,
            fullAmount,
        }));
    }, [fullAmount, group, payee, payer]);
    // Paying moves money, so on web it shows the QR code that opens the group in the app
    const onPay = useCallback(() => {
        Modal.hide(() => showUnavailableOnWeb(`emma://groups/${group.id}`, 'Pay debt'));
    }, [group.id]);
    return (<>
      {isPaying ? (isGBUser && (<SettingsItem icon={<IconBoldArrow alt gradientKey="apricot" direction="right"/>} title="Pay debt" onPress={onPay}/>)) : (<SettingsItem icon={<IconBell gradientKey="apricot"/>} title="Send reminder" onPress={onRemind}/>)}
      <SettingsItem icon={<IconRectangleListSolid gradientKey="orange"/>} title="Choose from your transactions" onPress={onFromTransactionScreen}/>
      <SettingsItem icon={<IconWifi off color={colors.status.offline}/>} title="Record offline transaction" onPress={onCustomTransaction}/>
    </>);
};
export const SettleUpModal = {
    show: (props) => {
        Modal.show(<SettleUpModalContent {...props}/>, {
            containerStyle: styles.modal,
            title: 'Settle up',
        });
    },
    hide: Modal.hide,
};
const styles = StyleSheet.create({
    modal: {
        paddingHorizontal: 0,
        overflow: 'hidden',
    },
});
